import {
  reactive,
  nextTick,
} from 'vue';
import {
  formatNumberLocale,
  parseNumberLocale,
  getLocaleSeparators,
} from '@/shared/utils/locale_number_utils.js';

export function useLocaleNumberInputForTable() {
  const focusedRows = reactive(new Map());

  const formatter = (val, precision, rowKey) => {
    if (focusedRows.get(rowKey)) {
      const { decimalSeparator } = getLocaleSeparators();
      return String(val ?? '').replace('.', decimalSeparator);
    }
    return formatNumberLocale(val, precision ?? undefined);
  };

  const parser = (val) => {
    const result = parseNumberLocale(val);
    return result !== undefined ? String(result) : '';
  };

  const handleFocus = (event, rowKey) => {
    focusedRows.set(rowKey, true);
    nextTick(() => {
      const input = event?.target;
      if (input?.tagName === 'INPUT' && input.value) {
        const { groupSeparator, decimalSeparator } = getLocaleSeparators();
        input.value = input.value.replaceAll(groupSeparator, '').replace('.', decimalSeparator);
      }
    });
  };

  const handleBlur = (event, modelValue, precision, rowKey) => {
    focusedRows.delete(rowKey);
    nextTick(() => {
      const input = event?.target;
      if (input?.tagName === 'INPUT') {
        input.value = formatNumberLocale(modelValue, precision ?? undefined);
      }
    });
  };

  return { formatter, parser, handleFocus, handleBlur };
}
